import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IoIosNotifications } from "react-icons/io";

import Tabs from "../../components/Tabs";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import CRUDPushGenerator from "./components/CRUDPushGenerator";

const options = ["PUSH"];

function PushGenerator() {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState("PUSH");

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          typeIcon="custom"
          title={t("PUSH_GENERATOR")}
          rightButton={<div id="renderButtonPush" />}
          icon={<IoIosNotifications size={40} color="##004fff" />}
        />

        <Tabs options={options} activeTab={activeTab} setActiveTab={setActiveTab}>
          {options[0] === activeTab && <CRUDPushGenerator />}
        </Tabs>
      </section>
    </div>
  );
}

export default PushGenerator;
